import { gql } from "@apollo/client";

export const GET_SCREEN = gql`
  query Screens {
    screens {
      screenName
      module
      Id
    }
  }
`;
